export const SEMANAL = {
  base: "/resumen-semanal", cap: "resumen_importar_cap", qk: "resumen", annual: false,
  title: "Resultados Semanales", histTitle: "Historial de Importaciones",
};

export const ANUAL = {
  base: "/resumen-anual", cap: "resumen_anual_importar_cap", qk: "anual", annual: true,
  title: "Resultado anual por semana", histTitle: "Historial anual",
};
